var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldDatatypeReference = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 0h17a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4m1.558 4.763V11h1.233V8.534h.738L8.798 11h1.422L8.699 8.246q.225-.126.419-.284t.328-.373.212-.5q.075-.283.076-.67 0-.522-.203-.873a1.55 1.55 0 0 0-.54-.558 2.3 2.3 0 0 0-.765-.292 4.4 4.4 0 0 0-.868-.086 13 13 0 0 0-.877.036 11 11 0 0 0-.923.117m1.89.945q.486 0 .738.23t.252.634q0 .54-.324.774t-.837.234h-.486V5.753a1.4 1.4 0 0 1 .284-.036q.184-.009.373-.009M11.03 4.7V11h4.176V9.902h-2.943V8.363h2.673V7.265h-2.673V5.798h2.898V4.7zm5.526 0V11h1.233V8.453h2.565V7.355h-2.565V5.798h2.763V4.7z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldDatatypeReference);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/field-datatype-reference.1d1aec36.svg";